var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rating rating-sm mt-1"},_vm._l((5),function(index){return _c('i',{key:index,staticClass:"las la-star",class:{ active: index <= _vm.star }})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }